interface Location {
  offset: number
  line: number
  column: number
}

interface PeggyEventBase {
  rule: string
  result: unknown
  location: Location
}

type PeggyEventMatch = PeggyEventBase & {
  type: 'rule.match'
  result: unknown
}

type PeggyEventEnter = PeggyEventBase & {
  type: 'rule.enter'
}

type PeggyEventFail = PeggyEventBase & {
  type: 'rule.fail'
}

type PeggyEvent = PeggyEventEnter | PeggyEventFail | PeggyEventMatch
interface PeggyEventWithDepth {
  event: PeggyEvent
  depth: number
}

export class PeggyTracer {
  private depth: number
  private readonly events: PeggyEventWithDepth[]

  public constructor() {
    this.depth = 0
    this.events = []
  }

  public trace(event: PeggyEvent) {
    if (event.type !== 'rule.enter') {
      this.depth -= 1
    }
    const eventWithDepth = {
      event,
      depth: this.depth,
    }
    this.events.push(eventWithDepth)
    if (this.depth < 13) {
      // 10以上はtermのはずで、冗長なので表示しない。
    }
    if (event.type === 'rule.enter') {
      this.depth += 1
    }
  }
}
